import App from '@/models/App'

export default class OrderingOrdererSenderList extends App {
    static get entity() {
        return 'OrderingOrdererSenderLists'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            companyName: this.attr(''),
            personName: this.attr(''),
            personEmail: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    // プロパティを追加、companyNameとpersonNameを結合
    get nameField() {
        return `${this.companyName} (${this.personName}/${this.personEmail})`
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/sender/lists`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/sender/lists`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingSenderListId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/sender/lists/${orderingSenderListId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingSenderListId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/sender/lists/${orderingSenderListId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingSenderListId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
